import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import CustomerPurchase from "./customerpurchase";
import Footer from "./Footer";
const PurchaseReport = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <CustomerPurchase />
      <Footer />
    </>
  );
};

export default PurchaseReport;
